import React, { useState } from 'react';
import { TextInput, Button, Modal, Text, Box, Alert, PasswordInput, Group, Divider } from '@mantine/core';
import { useAuth } from '../hooks/useAuth';

const AdminLogin = ({ opened, onClose, onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showCreateAdmin, setShowCreateAdmin] = useState(false);
  const { signIn, signInWithGoogle, createAdmin, loading, error } = useAuth();

  const handleLogin = async () => {
    if (!email || !password) {
      return;
    }

    const result = await signIn(email, password);
    
    if (result.success) {
      onLoginSuccess();
      setEmail('');
      setPassword('');
      setShowCreateAdmin(false);
    }
  };

  const handleGoogleSignIn = async () => {
    const result = await signInWithGoogle();
    
    if (result.success) {
      onLoginSuccess();
      setEmail('');
      setPassword('');
      setShowCreateAdmin(false);
    }
  };

  const handleCreateAdmin = async () => {
    if (!email || !password) {
      return;
    }

    const result = await createAdmin(email, password);
    
    if (result.success) {
      alert('Admin account created successfully! You can now sign in.');
      setShowCreateAdmin(false);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (showCreateAdmin) {
        handleCreateAdmin();
      } else {
        handleLogin();
      }
    }
  };

  const handleClose = () => {
    setEmail('');
    setPassword('');
    setShowCreateAdmin(false);
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={showCreateAdmin ? "Create Admin Account" : "Admin Access"}
      size="sm"
      centered
    >
      <Box p="md">
        {error && (
          <Alert color="red" mb="md">
            {error}
          </Alert>
        )}
        
        <TextInput
          label="Email"
          type="email"
          value={email}
          onChange={(event) => setEmail(event.currentTarget.value)}
          onKeyPress={handleKeyPress}
          placeholder="admin@amritvela.com"
          mb="md"
          disabled={loading}
        />
        
        <PasswordInput
          label="Password"
          value={password}
          onChange={(event) => setPassword(event.currentTarget.value)}
          onKeyPress={handleKeyPress}
          placeholder="Enter password"
          mb="md"
          disabled={loading}
        />
        
        <Group gap="sm">
          <Button 
            flex={1}
            onClick={showCreateAdmin ? handleCreateAdmin : handleLogin}
            variant="filled"
            color="#EBA75B"
            loading={loading}
            disabled={!email || !password}
          >
            {showCreateAdmin ? 'Create Admin' : 'Sign In'}
          </Button>
          
          {!showCreateAdmin && (
            <Button 
              variant="subtle"
              color="gray"
              onClick={() => setShowCreateAdmin(true)}
              disabled={loading}
            >
              Create Admin
            </Button>
          )}
          
          {showCreateAdmin && (
            <Button 
              variant="subtle"
              color="gray"
              onClick={() => setShowCreateAdmin(false)}
              disabled={loading}
            >
              Back to Sign In
            </Button>
          )}
        </Group>

        <Divider label="OR" labelPosition="center" my="md" />

        <Button 
          fullWidth
          onClick={handleGoogleSignIn}
          variant="outline"
          color="blue"
          loading={loading}
        >
          Sign In with Google
        </Button>
        
        <Text size="xs" c="dimmed" mt="md" ta="center">
          {showCreateAdmin 
            ? "Create the admin account for managing Sadhana sessions"
            : "Use your admin credentials to access the dashboard"
          }
        </Text>
      </Box>
    </Modal>
  );
};

export default AdminLogin;
